<script>
//Components
const Hero = () => import("@/components/media/Hero.vue");
const Faq = () => import("@/components/Faq.vue");
const WhoWeAre = () => import("@/views/home/components/WhoWeAre.vue");
const OurValues = () => import("@/views/home/components/OurValues.vue");
const Blog = () => import("@/views/home/components/Blog.vue");
const OurAreas = () => import("@/views/home/components/OurAreas.vue");
const OurBenefits = () => import("@/views/home/components/OurBenefits.vue");
const Midia = () => import("@/views/home/components/Midia.vue");
const ValueRelationship = () =>
  import("@/views/home/components/ValueRelationship.vue");

export default {
  watch: {},
  name: "Home",
  data() {
    return {};
  },
  head() {
    return this.$head({
      title: "",
    });
  },
  mounted() {
    this.$store.dispatch("opportunities/setOpportunities");
  },
  components: {
    Hero,
    Faq,
    WhoWeAre,
    OurValues,
    Blog,
    ValueRelationship,
    OurAreas,
    OurBenefits,
    Midia
  },
  computed: {},
};
</script>

<template>
  <div class="home">
    <Hero
      title="O que tem valor no <br /> seu trabalho?"
      :video="'hero-home.mp4'"
      height="75vh"
      :search="true"
    />
    <WhoWeAre />
    <OurValues />
    <Blog />
    <ValueRelationship />
    <OurAreas />
    <OurBenefits />
    <Midia />
  </div>
</template>

<style lang="scss">
.home {
  background-color: #f8f8f8;
}
</style>

